import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SwiperModule } from "swiper/angular";
import { SharedModule } from "../../shared/shared.module";

import { ViewTournamentComponent } from "./containers/view-tournament/view-tournament.component";
import { ViewTournamentPlayersAndPrizesComponent } from "./presenters/view-tournament-players-and-prizes/view-tournament-players-and-prizes.component";
import { ViewTournamentActiveTablesComponent } from "./presenters/view-tournament-active-tables/view-tournament-active-tables.component";
import { ViewTournamentStructureComponent } from "./presenters/view-tournament-structure/view-tournament-structure.component";
import { VewTournamentInfoComponent } from "./presenters/view-tournament-info/view-tournament-info.component";

import { DialogTournamentEndResultComponent } from "./presenters/dialog-tournament-end-result/dialog-tournament-end-result.component";
import { ViewTournamentStatusComponent } from "./presenters/view-tournament-status/view-tournament-status.component";
import { DialogTournamentRegistrationComponent } from "./presenters/dialog-tournament-registration/dialog-tournament-registration.component";
import { ButtonTournamentRegistrationComponent } from "./presenters/button-tournament-registration/button-tournament-registration.component";
import { LinkifyPipe } from "../../core/linkify.pipe";
import { ViewTournamentMobileTablesComponent } from "./presenters/mobile/view-tournament-mobile-tables/view-tournament-mobile-tables.component";
import { ViewTournamentContainerComponent } from "./presenters/mobile/view-tournament-container/view-tournament-container.component";
import { ViewTournamentMobileStructureComponent } from "./presenters/mobile/view-tournament-mobile-structure/view-tournament-mobile-structure.component";
import { ViewTournamentMobileStatusComponent } from "./presenters/mobile/view-tournament-mobile-status/view-tournament-mobile-status.component";
import { ViewTournamentMobileInfoIconsComponent } from "./presenters/mobile/view-tournament-mobile-info-icons/view-tournament-mobile-info-icons.component";
import { ViewTournamentMobileInfoComponent } from './presenters/mobile/view-tournament-mobile-info/view-tournament-mobile-info.component';
import { ViewTournamentMobilePlayersComponent } from './presenters/mobile/view-tournament-mobile-players/view-tournament-mobile-players.component';
import { ViewTournamentMobilePayoutsComponent } from './presenters/mobile/view-tournament-mobile-payouts/view-tournament-mobile-payouts.component';
import { TournamentEndDialogComponent } from './presenters/tournament-end-dialog/tournament-end-dialog.component';
import { TournamentEndDialogCantobyteComponent } from './presenters/tournament-end-dialog-cantobyte/tournament-end-dialog-cantobyte.component';

@NgModule({
  imports: [CommonModule, SharedModule, FormsModule, SwiperModule],
  declarations: [
    ViewTournamentComponent,
    VewTournamentInfoComponent,
    ViewTournamentPlayersAndPrizesComponent,
    ViewTournamentActiveTablesComponent,
    ViewTournamentStructureComponent,

    ViewTournamentStatusComponent,

    DialogTournamentEndResultComponent,
    DialogTournamentRegistrationComponent,

    ButtonTournamentRegistrationComponent,
    LinkifyPipe,
    ViewTournamentMobileTablesComponent,
    ViewTournamentContainerComponent,
    ViewTournamentMobileStructureComponent,
    ViewTournamentMobileStatusComponent,
    ViewTournamentMobileInfoIconsComponent,
    ViewTournamentMobileInfoComponent,
    ViewTournamentMobilePlayersComponent,
    ViewTournamentMobilePayoutsComponent,
    TournamentEndDialogComponent,
    TournamentEndDialogCantobyteComponent,
  ],
  exports: [ViewTournamentComponent, ButtonTournamentRegistrationComponent],
  entryComponents: [
    DialogTournamentEndResultComponent,
    TournamentEndDialogComponent,
    TournamentEndDialogCantobyteComponent,
    DialogTournamentRegistrationComponent,
  ],
})
export class TournamentModule {}
